// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var border = "NewsSection-module--border--15wHg";
export var section = "NewsSection-module--section--2yAmC";
export var newsCard = "NewsSection-module--newsCard--6026P";
export var image = "NewsSection-module--image--1SvKB";
export var alternateSquareImage = "NewsSection-module--alternateSquareImage--2mC_b";
export var articleText = "NewsSection-module--articleText--em5IN";
export var titleContainer = "NewsSection-module--titleContainer--GRAoa";
export var title = "NewsSection-module--title--1M3xj";
export var date = "NewsSection-module--date--1Qup1";
export var textContainer = "NewsSection-module--textContainer--31OaY";
export var extract = "NewsSection-module--extract--2VmlG";
export var readMoreLink = "NewsSection-module--readMoreLink--3E8m5";